import AdminView from "./AdminView";
import PengelolaView from "./PengelolaView";

export default function PermohonanView({ user }) {
  if (user?.key === "pts") {
    return (
      <div data-testid="permohonan-pts-note">
        <h1 className="font-display text-3xl font-semibold text-[#0B2440] md:text-4xl">
          Permohonan Informasi Publik
        </h1>
        <p className="mt-8 rounded-2xl border border-dashed border-[#E3EBF3] bg-white px-6 py-10 text-center text-sm leading-relaxed text-slate-400">
          Halaman ini hanya untuk Admin PPID dan Pengelola Dokumen.
        </p>
      </div>
    );
  }
  return user?.role === "ppid" ? (
    <AdminView user={user} />
  ) : (
    <PengelolaView user={user} />
  );
}